import React from 'react'
import {NotificationEntry} from './NotificationEntry'
import './Notifications.css'

export function Notifications({notificationList}: { notificationList: Array<string> }) {
    return (
        <div className="notifications">
            {notificationList.map((element, i) =>
                <React.Fragment key={i}>
                    <NotificationEntry text={element}/>
                </React.Fragment>)
            }
        </div>
    );
}